import React from 'react';
import { FiCode, FiFilm, FiLayers, FiUsers } from 'react-icons/fi';
import './About.css';
import studioImage from '../../media/studio.png';

const PILLARS = [
  {
    icon: <FiCode size={24} />,
    title: 'Software Development',
    desc: 'We architect and ship production-grade software — from mobile apps to full-stack web experiences.',
  },
  {
    icon: <FiFilm size={24} />,
    title: 'Digital Art & Video',
    desc: 'We produce original digital artwork and video content — visual storytelling crafted with intention.',
  },
  {
    icon: <FiLayers size={24} />,
    title: 'Creative Technology',
    desc: 'We blend technical precision with creative storytelling to build experiences that resonate.',
  },
  {
    icon: <FiUsers size={24} />,
    title: 'Community Driven',
    desc: 'Building tools and content for real people, shaped by genuine feedback and shared passion.',
  },
];

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="container" style={{ backgroundImage: `url(${studioImage})` }}>
        <div className="about__header">
          <p className="section-label">About Us</p>
          <h2 className="section-title">
            A Studio Built on <span className="gradient-text">Passion & Purpose</span>
          </h2>
          <p className="section-subtitle">
            CodeTunez Studios is a software and digital content company. We build software that
            solves real problems and produce original digital art and video that inspires.
          </p>
        </div>

        <div className="about__grid">
          {PILLARS.map((p, i) => (
            <div className="about__card" key={i}>
              <div className="about__card-icon">{p.icon}</div>
              <h3 className="about__card-title">{p.title}</h3>
              <p className="about__card-desc">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="about__mission">
          <div className="about__mission-content">
            <p className="section-label">Our Mission</p>
            <h3 className="about__mission-title">
              Empowering Creators &amp; Communities Through Technology
            </h3>
            <p className="about__mission-text">
              We founded CodeTunez Studios with a simple belief: the best products happen when developers
              think like artists and artists think like engineers. Every line of code we write and every
              piece of media we produce carries that spirit forward.
            </p>
            <div className="about__values">
              <p>Curiosity drives us to create.
                Passion drives us to explore.
                Creators inspire us to make</p>
            </div>
          </div>
          <div className="about__mission-visual">
            <div className="about__orb about__orb--1" />
            <div className="about__orb about__orb--2" />
            <div className="about__orb about__orb--3" />
            <div className="about__mission-badge">
              <span>EST.</span>
              <strong>2026</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
